<template>
  <div class="banner">
    <div class="container">
      <a-row>
        <a-col :xs="24" :lg="12">
          <a-typography-title :level="1">
            重磅发布！
          </a-typography-title>
          <a-typography-title :level="5">
            《星汉未来Serverless行业白皮书》
          </a-typography-title>
          <!--<a-typography-paragraph>-->
          <!--</a-typography-paragraph>-->
          <a-button type="link" class="button_1"
                    @click="download(href.book)">
            查看完整白皮书
          </a-button>
        </a-col>
      </a-row>
    </div>
  </div>
  <section v-for="v in expand.list" class="section">
    <div class="container">
      <a-typography-title v-if="v.title" :level="1">
        {{ v.title }}
      </a-typography-title>
      <a-typography-paragraph v-if="v.text">
        <p v-for="t in v.text.split('<br>')">
          {{ t }}
        </p>
      </a-typography-paragraph>
      <img v-if="v.image" alt=""
           :src="v.image" />
    </div>
  </section>
  <section class="section">
    <div class="container">
      <a-button type="link" class="button_1"
                @click="download(href.book)">
        查看完整报告
      </a-button>
    </div>
  </section>
  <section class="section box_href">
    <div class="container">
      <a-typography-title :level="2">
        更多白皮书
      </a-typography-title>
      <router-link class="button_1"
                   :to="$Enum.RouterEnum.BookCostOptimization">
        成本优化白皮书
      </router-link>
      <router-link class="button_1"
                   :to="$Enum.RouterEnum.BookDevOps">
        运维方案白皮书
      </router-link>
      <a-button type="link" class="button_1" target="_blank"
                :href="href.book_1">
        在离线混部白皮书
      </a-button>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/book/industry/1.png';
import Image_2 from '@resource/image/book/industry/2.png';
import Image_3 from '@resource/image/book/industry/3.png';
import Image_4 from '@resource/image/book/industry/4.png';
import Image_5 from '@resource/image/book/industry/5.png';

export default {
  name: 'book_costOptimization',
  props: [
    'download'
  ],
  data(): DataInterface {
    return {
      href: {
        book: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5Serverless%E8%A1%8C%E4%B8%9A%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf',
        book_1: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5%E5%9C%A8%E7%A6%BB%E7%BA%BF%E6%B7%B7%E9%83%A8%E6%96%B9%E6%A1%88%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf'
      },
      expand: {
        list: [
          {
            title: '前言',
            text: '本文为您解读Serverless技术的定义、发展历程、行业生态现状以及典型落地案例，' +
              '帮助您快速了解Serverless的行业发展趋势。'
          },
          {
            title: '目录',
            image: Image_1
          },
          {
            title: '发展大事记',
            image: Image_2
          },
          {
            title: 'Serverless架构',
            image: Image_3
          },
          {
            title: '应用场景',
            image: Image_4
          },
          {
            title: '问题及发展趋势',
            image: Image_5
          }
        ]
      }
    };
  },
  
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}book/industry/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    z-index: 0;
    margin: 0 auto;
    padding: 150px 0 70px;
    
    h1.ant-typography {
      .font(left, 54px, @color_white, 50px, true);
    }
    
    h5.ant-typography {
      margin: 1.2em 0;
      .font(left, 34px, @color_white, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      position: relative;
      padding: 10px 0;
      .font(left, @font_6+@line, @color_white, @font_6);
      
      &::before {
        content: '';
        display: block;
        .center();
        z-index: -1;
        .bg('@{src_image}page/home/banner_text.png', 110%, 100%, true);
      }
    }
    
    .button_1 {
      width: 150px !important;
    }
  }
}

.section {
  overflow: hidden;
  position: relative;
  background-color: @color_7;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    padding: 50px 20px;
    margin: 0 auto;
    border-left: 1px solid fade(@color_black, 10);
    border-right: 1px solid fade(@color_black, 10);
    
    img {
      display: block;
      width: 100%;
    }
    
    h1.ant-typography {
      .font(left, 50px, @color_black, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      .font(justify, 40px, @color_3, 18px);
      text-indent: 2em;
    }
    
    .text {
      max-width: 600px;
      margin: 0 auto;
      text-indent: 0 !important;
      
      ul {
        li {
          list-style-type: circle;
        }
      }
    }
    
    .qr {
      width: 300px;
      margin: 30px auto 10px;
    }
    
    .button_1 {
      width: auto !important;
      padding: 0 15px !important;
      margin: 30px auto;
    }
  }
}

.box_href {
  text-align: center;
  
  h2.ant-typography {
    margin-bottom: 30px;
    .font(center, 40px, @color_3, 30px);
  }
  
  .button_1 {
    display: inline-block !important;
    width: auto !important;
    padding: 0 15px !important;
    margin: 0 10px 20px !important;
    vertical-align: top;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 100px 0 50px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .banner {
    .container {
      h1.ant-typography {
        margin: 0;
        .font(justify, 34px, @color_white, 26px, true);
      }
      
      h5.ant-typography {
        margin: 0 0 20px;
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
      
      div.ant-typography {
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
    }
  }
  
  .section {
    .container {
      h1.ant-typography {
        .font(left, 40px, @color_black, 26px, true);
      }
    }
  }
  
  .box_href {
    h2.ant-typography {
      .font(center, 40px, @color_3, 26px);
    }
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>